import useApi from "@/hooks/useApi.ts";
import {
  Company,
  CompanyUp,
  CompanyUpdateUp,
} from "@/types/Company.ts";

type UseCompanyApiHook = {
  token?: string;
  getCompany: (email?: string) => Promise<Company>;
  updateCompany: (data: CompanyUpdateUp) => Promise<void>;
  registerCompany: (data: CompanyUp) => Promise<void>;
};

const useCompanyApi = (): UseCompanyApiHook => {
  const { token, apiPut, apiPost, apiGet } = useApi();

  const registerCompany = (data: CompanyUp): Promise<void> => {
    return apiPost<CompanyUp, void>("/company", data);
  };

  const updateCompany = (data: CompanyUpdateUp): Promise<void> => {
    return apiPut<CompanyUpdateUp, void>("/company", data);
  };

  const getCompany = (email?: string): Promise<Company> => {
    const path = email ? `/company/${email}` : `/company`;
    return apiGet<Company>(path);
  };


  return {
    token,
    getCompany,
    registerCompany,
    updateCompany,
  };
};

export default useCompanyApi;
